/**
 * RestoreIcon - Restore-Icon für Windows Window Controls
 *
 * Zwei überlappende Rechtecke. Wird angezeigt wenn das Fenster maximiert ist.
 *
 * @example
 * ```tsx
 * <RestoreIcon />
 * <RestoreIcon size={11} />
 * ```
 */
export const RestoreIcon = ({ size = 11 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6.5C9.55 6.5 9.9 6.05 9.9 5.5V1.5C9.9 0.95 9.45 0.5 8.9 0.5H4.9C4.35 0.5 3.9 0.85 3.9 1.4M6.5 2.9H1.5C0.95 2.9 0.5 3.35 0.5 3.9V8.9C0.5 9.45 0.95 9.9 1.5 9.9H6.5C7.05 9.9 7.5 9.45 7.5 8.9V3.9C7.5 3.35 7.05 2.9 6.5 2.9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
